import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../redux';
import { SpriteImage } from '../../SpriteImage/SpriteImage';
// import viewFolderStyles from './../viewfolders.module.scss';
import './SearchSender.scss';

export default function SearchSender(props: any) {
    const { formatMessage } = useIntl();
    // const searchValue = useRef();
    const [search, setSearch] = useState('');
    const { selectedSender } = useSelector(({ mailbox }: IRootState) => ({
        selectedSender: mailbox.selectedSender,
    }));

    const textBoxOnChange = () => {
        setSearch('');
    };
    useEffect(() => {
        search.length != 0 ? props.onSenderNameChange(search) : props.onSenderNameChange('');
    }, [search]);

    useEffect(() => {
        selectedSender == null && setSearch('');
    }, [selectedSender]);

    return (
        <div className="filterSendersList">
            <div className="searchIcon">
                <SpriteImage className="searchUserIcon" />
            </div>
            <div className="searchInput">
                <input
                    className="filterInput inputPlaceholderGrey"
                    type="text"
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder={formatMessage({ id: 'SEARCH_SENDER_PLACEHOLDER' })}
                    value={search}
                />
                <div className="clearButtonDiv">
                    {search.length != 0 && (
                        <button className="clearButton" onClick={textBoxOnChange}>
                            x
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
